import { Stack, Typography } from '@mui/material';
import ROUTES from 'constants/routes';
import qs from 'qs';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';

interface AuthTabsProps {
  activeTab: 'login' | 'register';
  redirectUrl?: string;
}

const AuthTabs = ({ activeTab, redirectUrl }: AuthTabsProps) => {
  const { t } = useTranslation();

  const tabs = [
    {
      key: 'login',
      label: t('loginPage.loginTab'),
      to: ROUTES.LOGIN,
    },
    {
      key: 'register',
      label: t('register.link'),
      to: {
        pathname: ROUTES.REGISTER,
        search: qs.stringify({ redirectUrl }),
      },
    },
  ] as const;

  return (
    <Stack
      direction='row'
      spacing={4}
      sx={{
        pb: 2,
        borderBottom: '1px solid',
        borderColor: '#D9E2FF',
      }}>
      {tabs.map((tab) => {
        const isActive = activeTab === tab.key;

        return (
          <Typography
            key={tab.key}
            component={RouterLink}
            to={tab.to}
            sx={{
              textDecoration: 'none',
              color: isActive ? 'primary.main' : 'text.disabled',
              fontSize: 20,
              fontWeight: 600,
              lineHeight: 1.2,
              pb: 1,
              borderBottom: '3px solid',
              borderColor: isActive ? 'primary.main' : 'transparent',
            }}>
            {tab.label}
          </Typography>
        );
      })}
    </Stack>
  );
};

export default AuthTabs;
